import { $ } from '@starberry/components';
import { Icon } from '@chakra-ui/react';

export default {
  $: 'Box',
  props: {
    py: [8, null, 16],
    color: $('constants.colors.text'),
  },

  icon: '',
  heading: $('constants.translations.noContent.NO_CONTENT_PROP_TITLE', 'No items found'),
  description: $(
    'constants.translations.noContent.NO_CONTENT_PROP_SUBTITLE',
    'Consider changing your filter parameters'
  ),

  children: (props) => [
    {
      $: 'Stack',
      props: {
        align: 'center',
        opacity: 0.35,
        spacing: 0,
        textAlign: 'center',
      },
      children: [
        props.icon && {
          component: Icon,
          fontSize: 30,
          as: $(`constants.icons.${props.icon}`),
        },
        {
          $: 'Text',
          props: {
            fontSize: $('constants.headings.headingSize.h6'),
            lineHeight: '1.2',
            color: $('constants.colors.text'),
            fontWeight: 'bold',
          },
          children: props.heading,
        },
        {
          $: 'Text',
          props: {
            color: $('constants.colors.text'),
            fontSize: $('constants.body.bodySize.large'),
            lineHeight: $('constants.body.bodyLineHeight.large'),
            pt: 1,
          },
          children: props.description,
        },
      ],
    },
  ],
};
